export enum BodyEventTypes {
    COLOR_CHANGE = 'colorChange',
    INTERIOR_CHANGE = 'interiorChange',
    GLASS_TONE_CHANGE = 'glassToneChange',
    CHANGE_BODY_MATERIAL = 'changeBodyMaterial',
    CHANGE_INTERIOR_MATERIAL = 'changeInteriorMaterial',
}
